import { createSelector } from "reselect";

function getCreativeVersions(state){
	return state.creativeVersions?.items;
}

function getCreativeDetailsInfo(state){
	return {
		creativeId: state.creativeDetails?.id,
	};
}

function findDefaultVersion({ items, creativeId }){
	let defaultVersion = items?.find(item => item.name === "default") || null
		, selectedCreativeId = defaultVersion?.creative?.id || null
		, matchedCreative = selectedCreativeId === creativeId
		;

	if(matchedCreative){
		return {
			defaultVersion,
		};
	}

	return null;
}

export const getDefaultVersion = createSelector([getCreativeVersions, getCreativeDetailsInfo], findDefaultVersion);

export const PRIVATE = {
	getCreativeVersions,
	getCreativeDetailsInfo,
	findDefaultVersion,
	getDefaultVersion,
};
